import { Component, input } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

// Components
import { AnimatedLoadingComponent } from "../animated-loading/animated-loading.component";

// TAS Search Library - Models
import { Result } from 'aisearch-search-fe-library';

// Font Awesome
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

// Pipes
import { AsyncPipe } from '@angular/common';
import { MarkdownPipe } from 'ngx-markdown';


@Component({
  selector: 'app-answer',
  imports: [FontAwesomeModule, AnimatedLoadingComponent, MarkdownPipe, AsyncPipe],
  templateUrl: './answer.component.html',
  styleUrls: ['./answer.component.scss']
})
export class AnswerComponent {
  readonly query = input<string>();
  readonly answer = input<string>();
  readonly answerWithCitations = input<SafeHtml>();
  readonly results = input<Result[]>([]);
  readonly loading = input<boolean>(false);

  faCircle = faCircle;
}
